// copied from calling-remote-app/static/js/navigation/hooks/useShowConnectionErrorAlerts.ts
// does not include open remote handling
import { useMemo } from 'react';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
import { useConnectionStatus } from 'worker-connection-library/hooks/useConnectionStatus';
export const useHasConnectionError = () => {
  const connectionStatus = useConnectionStatus();
  const hasConnectionUnsupported = useMemo(() => connectionStatus === ConnectionStatusTypes.UNSUPPORTED, [connectionStatus]);
  const hasConnectionError = useMemo(() => connectionStatus === ConnectionStatusTypes.FAILED, [connectionStatus]);
  const hasConnectionDeprecated = useMemo(() => connectionStatus === ConnectionStatusTypes.DEPRECATED, [connectionStatus]);
  return {
    hasConnectionError,
    hasConnectionDeprecated,
    hasConnectionUnsupported
  };
};